<mat-card appearance="outlined" class="pigeon-legend-card">
  <!--TODO: positioning isnt right-->
  <button
    class="btn-top"
    mat-icon-button
    color="primary"
    (click)="onClickScrollToTop()">
    <fa-icon [icon]="['far', 'chevron-up']"></fa-icon>
  </button>
  <mat-tab-group>
    <!-- ROUTE LEGEND -->
    <mat-tab>
      <ng-template mat-tab-label>
        <!--TODO: add to translation file-->
        Info
      </ng-template>
      <div class="control-card-help">
        <p>
          Die digitalen Flugrouten werden automatisch aus den Eingabeparametern
          Auflassort, Zielort und Geschwindigkeit berechnet.
        </p>
        <p>
          Je Flugstunde wird eine Wetterstation entlang der Route in der
          Farb-Matrix (linker Bereich) angezeigt. Dabei finden sowohl offizielle
          Stationen der nationalen Wetterdienste als auch virtuelle Stationen
          Verwendung.
        </p>
        <p>
          Wählen Sie den Wochentag und die Startzeit aus. In der Farb-Matrix
          sehen sie sofort die Flugbedingungen für die Route.
        </p>
        <p>
          Auf der Karte im rechten Bereich wird der Routenverlauf geografisch
          angezeigt. Je Linienabschnitt werden die Flugbedingungen farblich
          visualisiert. Die Taube markiert den ausgewählten Streckenabschnitt.
          Dieser lässt sich durch Verschieben der Taube, Klicken in eine Zeile
          der Farbmatrix oder Auswahl einer Wetterstation der
          Punktprognose-Tabelle verändern.
        </p>
        <p>Die Farben haben folgende Bedeutung:</p>
        <table>
          <tr>
            <td class="info-legend-color index0"></td>
            <td>gute Flugbedingungen</td>
          </tr>
          <tr>
            <td class="info-legend-color index1"></td>
            <td>leicht eingeschränkte Flugbedingungen</td>
          </tr>
          <tr>
            <td class="info-legend-color index2"></td>
            <td>spürbar eingeschränkte Flugbedingungen</td>
          </tr>
          <tr>
            <td class="info-legend-color index3"></td>
            <td>stark eingeschränkte Flugbedingungen</td>
          </tr>
          <tr>
            <td class="info-legend-color index4"></td>
            <td>Flug nicht möglich</td>
          </tr>
        </table>
        <br />

        <p>
          Klicken Sie auf das
          <fa-icon [icon]="['far', 'circle-question']" size="lg"></fa-icon> im
          jeweiligen Bereich, um mehr Informationen darüber zu erhalten, oder
          schauen Sie sich das
          <fa-icon [icon]="['far', 'video']"></fa-icon> Tutorial an.
        </p>

        <p>
          Nutzen Sie die
          <fa-icon [icon]="['far', 'print']" size="lg"></fa-icon> Druckfunktion,
          um die Flugrouteninformationen, anhand der Sie eine Entscheidung
          getroffen haben als Ausdruck oder PDF zu behalten.
        </p>
      </div>
    </mat-tab>
    <!--STANDARD LEGEND-->
    <mat-tab>
      <ng-template mat-tab-label>
        <!--TODO: add to translation file-->
        Standard-Legende
      </ng-template>
      <table
        class="tauben-big-legend"
        border="1"
        frame="void"
        rules="rows"
        bordercolor="lightgrey">
        <tr>
          <td>&nbsp;</td>
          <th class="index0">0</th>
          <th class="index1">1</th>
          <th class="index2">2</th>
          <th class="index3">3</th>
          <th class="index4">4</th>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"><i class="far fa-dove"></i></span
            >Tauben-Index
          </td>
          <td>perfekt</td>
          <td>leicht eingeschränkt</td>
          <td>spürbar eingeschränkt</td>
          <td>stark eingeschränkt</td>
          <td>Flug nicht möglich</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"><i class="far fa-windsock"></i></span
            >Wind
          </td>
          <td></td>
          <td>leichter Windstress</td>
          <td>mittlerer Windstress</td>
          <td>starker Windstress</td>
          <td>extremer Windstress</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-temperature-frigid"></i></span
            >Kälte
          </td>
          <td></td>
          <td>leichter Kältestress</td>
          <td>mittlerer Kältestress</td>
          <td>starker Kältestress</td>
          <td>extremer Kältestress</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-temperature-hot"></i></span
            >Hitze
          </td>
          <td></td>
          <td>leichter Hitzestress</td>
          <td>mittlerer Hitzestress</td>
          <td>starker Hitzestress</td>
          <td>extremer Hitzestress</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"><i class="far fa-dewpoint"></i></span
            >Schwüle
          </td>
          <td></td>
          <td>leichte Schwüle</td>
          <td>mittlere Schwüle</td>
          <td>starke Schwüle</td>
          <td>extreme Schwüle</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-layer-group"></i></span
            >Inversion
          </td>
          <td></td>
          <td>leichte Inversion</td>
          <td>mittlere Inversion</td>
          <td>starke Inversion</td>
          <td>extreme Inversion</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-binoculars"></i></span
            >Sichweite
          </td>
          <td></td>
          <td>leichtes Nebelrisiko</td>
          <td>mittleres Nebelrisiko</td>
          <td>starkes Nebelrisiko</td>
          <td>extremes Nebelrisiko</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-cloud-download-alt"></i></span
            >Niedrige Bewölkung
          </td>
          <td></td>
          <td>recht viele tiefe Wolken</td>
          <td>viele tiefe Wolken</td>
          <td>fast geschlossene tiefe Wolkendecke</td>
          <td>geschlossene tiefe Wolkendecke</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-cloud-upload-alt"></i></span
            >Höhere Bewölkung
          </td>
          <td></td>
          <td>leichte Gefahr für strukturlose höhere Wolken</td>
          <td>mittlere Gefahr für strukturlose höhere Wolken</td>
          <td>hohe Gefahr für strukturlose höhere Wolken</td>
          <td></td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"><i class="far fa-clouds"></i></span
            >Effektiver Bedeckungsgrad (kein Sonnenschein)
          </td>
          <td></td>
          <td>leichte Gefahr für sonnenscheinloses Wetter</td>
          <td>mittlere Gefahr für sonnenscheinloses Wetter</td>
          <td>hohe Gefahr für sonnenscheinloses Wetter</td>
          <td>sehr hohe Gefahr für sonnenscheinloses Wetter</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-cloud-showers-heavy"></i></span
            >Niederschlag
          </td>
          <td></td>
          <td>leichtes Regenrisiko</td>
          <td>mittleres Regenrisiko</td>
          <td>hohes Regenrisiko</td>
          <td>extremes Regenrisiko</td>
        </tr>
        <tr>
          <td>
            <span class="legend-parameter"
              ><i class="far fa-thunderstorm"></i></span
            >Gewitter
          </td>
          <td></td>
          <td>leichtes Unwetterpotenzial</td>
          <td>mittleres Unwetterpotenzial</td>
          <td>starkes Unwetterpotenzial</td>
          <td>extremes Unwetterpotenzial</td>
        </tr>
      </table>
    </mat-tab>
    <!-- PROFI LEGEND -->
    <mat-tab>
      <ng-template mat-tab-label>
        <!--TODO: add to translation file-->
        Profi-Legende
      </ng-template>
      <table
        class="tauben-big-legend"
        border="1"
        frame="void"
        rules="rows"
        bordercolor="lightgrey">
        <tr>
          <td>&nbsp;</td>
          <th class="index0">0</th>
          <th class="index1">1</th>
          <th class="index2">2</th>
          <th class="index3">3</th>
          <th class="index4">4</th>
          <th>Wetterparameter</th>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter"><i class="far fa-dove"></i></div>
              <div>Tauben-Index</div>
            </div>
          </td>
          <td>perfekt</td>
          <td>leicht eingeschränkt</td>
          <td>spürbar eingeschränkt</td>
          <td>stark eingeschränkt</td>
          <td>Flug nicht möglich</td>
          <td></td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-windsock"></i>
              </div>
              <div>Wind</div>
            </div>
          </td>
          <td></td>
          <td>&ge; 25 km/h</td>
          <td>&ge; 31 km/h</td>
          <td>&ge; 41 km/h</td>
          <td>&ge; 50 km/h</td>
          <td>Wind in 120 m Höhe</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-temperature-frigid"></i>
              </div>
              <div>Kältestress</div>
            </div>
          </td>
          <td></td>
          <td>≤ 8,0°C</td>
          <td>≤ 5,0°C</td>
          <td>≤ 2,0°C</td>
          <td>≤ 0,0°C</td>
          <td>Temperatur in 2 m Höhe</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-temperature-hot"></i>
              </div>
              <div>Hitzestress</div>
            </div>
          </td>
          <td></td>
          <td>&ge; 25,0°C</td>
          <td>&ge; 27,5°C</td>
          <td>&ge; 30,0°C</td>
          <td>&ge; 32,5°C</td>
          <td>Temperatur in 2 m Höhe</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-dewpoint"></i>
              </div>
              <div>Schwüle</div>
            </div>
          </td>
          <td></td>
          <td>&ge; 24,0°C & &ge; 15,5°C</td>
          <td>&ge; 26,0°C & &ge; 17,0°C</td>
          <td>&ge; 28,0°C & &ge; 18,5°C</td>
          <td>&ge; 30,0°C & &ge; 20,0°C</td>
          <td>Temperatur und Taupunkt in 2 m Höhe</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-layer-group"></i>
              </div>
              <div>Inversion (bis 11.06./ab 30.07.)</div>
            </div>
          </td>
          <td></td>
          <td>&le; -1 K</td>
          <td>&le; -2 K</td>
          <td>&le; -4 K</td>
          <td>&le; -5 K</td>
          <td>Temperatur (2 m) - Temperatur (950 hPa Niveau)</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-layer-group"></i>
              </div>
              <div>Inversion (11.06. bis 30.07.)</div>
            </div>
          </td>
          <td></td>
          <td>&le; -3 K</td>
          <td>&le; -4 K</td>
          <td>&le; -5 K</td>
          <td>&le; -6 K</td>
          <td>Temperatur (2 m) - Temperatur (950 hPa Niveau)</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-binoculars"></i>
              </div>
              <div>Sichweite</div>
            </div>
          </td>
          <td></td>
          <td>&lt; 10,0 km</td>
          <td>&lt; 7,5 km</td>
          <td>&lt;5,0 km</td>
          <td>&lt; 3,0 km</td>
          <td>Sichtweite in km</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-cloud-download-alt"></i>
              </div>
              <div>Niedrige Bewölkung</div>
            </div>
          </td>
          <td></td>
          <td>≥ 6/8</td>
          <td>≥ 7/8</td>
          <td>≥ 7,5/8</td>
          <td>≥ 7,9/8</td>
          <td>Tiefe Wolken</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-cloud-upload-alt"></i>
              </div>
              <div>Mittlere und Höhere Bewölkung</div>
            </div>
          </td>
          <td></td>
          <td>≥ 7/8 & < 40 min Sonne</td>
          <td>≥ 7/8 & < 25 min Sonne</td>
          <td>= 8/8 & < 15 min Sonne</td>
          <td></td>
          <td>Hohe/mittelhohe Wolken & stdl. Sonnenscheindauer</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter"><i class="far fa-cloud"></i></div>
              <div>
                Bewölkung (keine Sonne)<br />"Effektiver Bedeckungsgrad"
              </div>
            </div>
          </td>
          <td></td>
          <td>≥ 7/8 & < 15 min Sonne</td>
          <td>≥ 7/8 & < 11 min Sonne</td>
          <td>= 8/8 & < 7 min Sonne</td>
          <td>= 8/8 & < 3 min Sonne</td>
          <td>Eff. Bedeckungsgrad & stdl. Sonnenscheindauer</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-cloud-showers-heavy"></i>
              </div>
              <div>Niederschlag</div>
            </div>
          </td>
          <td></td>
          <td>≥ 18 %</td>
          <td>≥ 33% & ≥ 0,1 mm</td>
          <td>≥ 48% & ≥ 0,3 mm</td>
          <td>≥ 63% & ≥ 0,6 mm</td>
          <td>Stündliche Wahrscheinlichkeit & Menge</td>
        </tr>
        <tr>
          <td>
            <div class="legend-parameter-cell">
              <div class="legend-parameter">
                <i class="far fa-thunderstorm"></i>
              </div>
              <div>Gewitter</div>
            </div>
          </td>
          <td></td>
          <td>≥ 1 leichtes Unwetterpotenzial</td>
          <td>≥ 2 mittleres Unwetterpotenzial</td>
          <td>≥ 3 starkes Unwetterpotenzial</td>
          <td>≥ 4 extremes Unwetterpotenzial</td>
          <td>Gewitter-Index</td>
        </tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</mat-card>
